import produce from 'immer';

const INITIAL_STATE = {
  daysWeek: [],
  blockDates: [],
  counties: [],
  quotas: [],
  countiesProduts: [],
};

export default function unityRegistration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@vehicleregistration/VEHICLE_DAYSWEEK': {
        draft.daysWeek = action.payload.value;
        break;
      }

      case '@vehicleregistration/VEHICLE_BLOCKDATES': {
        draft.blockDates = action.payload.value;
        break;
      }

      case '@vehicleregistration/VEHICLE_COUNTIES': {
        draft.counties = action.payload.value;
        break;
      }

      case '@vehicleregistration/VEHICLE_QUOTAS': {
        draft.quotas = action.payload.value;
        break;
      }

      case '@vehicleregistration/MUNICIPIOPRODUTOS': {
        draft.countiesProduts = action.payload.value;
        break;
      }

      case '@vehicleregistration/VEHICLE_RESETVALUES': {
        draft.daysWeek = [];
        draft.blockDates = [];
        draft.counties = [];
        draft.quotas = [];
        draft.countiesProduts = [];
        break;
      }

      default:
    }
  });
}
